import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import DraggableScroll from '../draggableScroll';
import Answers from './answers';
import { usePreviousValue } from '../../../utility/hooks';
import { updateScrollPosition } from '../../../utility/fillSurveyUtils';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
  },
  questionTitle: {
    fontSize: 16,
    lineHeight: '20px',
    wordBreak: 'break-word',
    marginBottom: spacing(3),
    [breakpoints.up('sm')]: {
      fontSize: 24,
      lineHeight: '28px',
      marginBottom: spacing(6),
    },
  },
  scroll: {
    height: '100%',
  },
}));

const QuestionnaireQuestion = ({
  className = null,
  scrollClass = null,
  translations,
  question,
  subjects = [],
  results = {},
  answerReplyErrors = {},
  isSingleReview = false,
  isPreview = false,
  isHistoryView = false,
  onSetAnswerReplyErrors = () => {},
  onAnswerSelect = () => {},
  onAnswerChange = () => {},
  onDraftChange = () => {},
}) => {
  const classes = useStyles();
  const draggableScrollRef = useRef(null);
  const previousQuestion = usePreviousValue(question);

  useEffect(() => {
    if (previousQuestion?.id !== question?.id) {
      updateScrollPosition(draggableScrollRef.current);
    }
  }, [previousQuestion, question]);

  return (
    <DraggableScroll
      ref={el => {
        draggableScrollRef.current = el;
      }}
      className={classNames(classes.scroll, scrollClass)}
      showDesktopScrollbars
    >
      <div className={classNames(classes.root, className)}>
        <Typography className={classes.questionTitle} variant="h3">
          {question.text}
        </Typography>
        <Answers
          translations={translations}
          question={question}
          subjects={subjects}
          results={results}
          answerReplyErrors={answerReplyErrors}
          isSingleReview={isSingleReview}
          isPreview={isPreview}
          isHistoryView={isHistoryView}
          onSetAnswerReplyErrors={onSetAnswerReplyErrors}
          onSelect={onAnswerSelect}
          onChange={onAnswerChange}
          onDraftChange={onDraftChange}
        />
      </div>
    </DraggableScroll>
  );
};

QuestionnaireQuestion.propTypes = {
  className: PropTypes.string,
  scrollClass: PropTypes.string,
  translations: PropTypes.shape({}).isRequired,
  isSingleReview: PropTypes.bool,
  isPreview: PropTypes.bool,
  isHistoryView: PropTypes.bool,
  question: PropTypes.shape({}).isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape({})),
  results: PropTypes.shape({}),
  answerReplyErrors: PropTypes.shape({}),
  onSetAnswerReplyErrors: PropTypes.func,
  onAnswerSelect: PropTypes.func,
  onAnswerChange: PropTypes.func,
  onDraftChange: PropTypes.func,
};

export default QuestionnaireQuestion;
